import axios from "axios";

export default {
  namespaced: true,
  state: {
    id: null,
    login: null,
    password: null,
    schoolId: null,
    selectedSubjects: null,          // 【担当教科】描画用に加工された、現在選択済みのもの
    subjectTeachers: [],             // 【担当教科】DBから取得した無加工のもの
    subjectTeachersAttributes: null, // 【担当教科】登録用に整形済みのもの
  },

  getters: {
    title: state => {
      return state.id ? '編集' : '新規作成'
    },
    isEdit: state => {
      return state.id ? true : false
    },
    passwordLabel: state => {
      return state.id ? 'パスワード再設定' : 'パスワード'
    },
    url: state => {
      return state.id
        ? `api/v1/admin/teachers/${state.id}`
        : 'api/v1/admin/teachers'
    },
    method: state => {
      return state.id ? 'PUT' : 'POST'
    },
    data( state, getters, rootState ) {
      return {
        type:      'Teacher',
        login:     state.login,
        uid:       state.login,
        password:  state.password,
        school_id: rootState.school.id,
        subject_teachers_attributes: state.subjectTeachersAttributes
      };
    },
  },

  mutations: {
    setId(state, payload) {
      state.id = payload.id;
    },
    setLogin(state, payload) {
      state.login = payload.login
    },
    setPassword(state, payload) {
      state.password = payload.password
    },
    setSelectedSubjects(state, payload) {
      state.selectedSubjects = payload.selectedSubjects
    },
    setSubjectTeachersAttributes(state, payload) {
      state.subjectTeachersAttributes = payload.subjectTeachersAttributes
    },
    setSchoolId(state, payload) {
      state.schoolId = payload.schoolId
    },
    setAccount(state, payload) {
      state.id               = payload.id;
      state.login            = payload.login_id;
      state.password         = payload.password;
      state.selectedSubjects = payload.selectedSubjects;
      state.subjectTeachers  = payload.subject_teachers;
    },
    initialize(state) {
      state.id               = '';
      state.login            = '';
      state.password         = '';
      state.selectedSubjects = '';
      state.subjectTeachers = [];
    },
  },

  actions: {

    async validate({ state }) {
      // ログインIDが入力されているか
      if (!state.login) return {status: 'error', message: 'ログインIDを入力してください'}
      // ログインIDが10文字以内か
      if (state.login.length > 10) return {status: 'error', message: 'ログインIDは10文字以内で入力してください'}
      // ログインIDが半角英数か(ハイフン含む)
      if (!state.login.match(/^[a-zA-Z0-9\\-]+$/)) return {status: 'error', message: 'ログインIDは半角英数字とハイフン「-」のみで入力してください'}

      if (!state.id) {
        // パスワードが入力されているか（必須チェックは新規登録時のみ）
        if (!state.password) return {status: 'error', message: 'パスワードを入力してください'}
      }
      if(!state.id || (state.id && state.password)) {
        // パスワードチェックを行うのは新規登録の時、編集でパスワード再設定を行う時
        // パスワードが10文字以内か
        if (state.password.length > 10) return {status: 'error', message: 'パスワードは10文字以内で入力してください'}
        // パスワードが半角英数か
        if (state.password != null && !state.password.match(/^[a-zA-Z0-9]+$/)) return {status: 'error', message: 'パスワードは半角英数字で入力してください'}
      }

      // 担当教科が選択されているか
      function isEmpty(obj){
        return !Object.keys(obj).length;
      }
      if (isEmpty(state.selectedSubjects)) return {status: 'error', message: '担当教科を選択してください'}

      return {status: 'success', message: ''}
    },

    async submit({ getters }) {
      const data    = getters.data
      const url     = getters.url
      const method  = getters.method
      const title   = getters.title

      await axios({
        url: url,
        method: method,
        data: data,
      })
      return {message: `${title}が完了しました` }
    },
  },
}
